import React, { useMemo } from 'react';

import { KeyboardDatePicker } from '@material-ui/pickers';
import { format, isValid } from 'date-fns';

import DATE_FORMAT from 'config/constants/DATE_FORMAT';

import { getRopaReviewDeadlineBounds, parseRopaReviewDeadlineDate } from '../validateRopaReviewDeadline';

type Props = {
  autoFocus?: boolean;
  error: string;
  id: string;
  label: string;
  onChange: (value: string) => void;
  value: string;
};

const passThroughInput = (input: string) => input;
const neverRefuse = /$^/;

const RopaReviewDeadlineField: React.FC<Props> = ({ autoFocus = false, error, id, label, onChange, value }) => {
  const { tomorrow, max } = useMemo(() => getRopaReviewDeadlineBounds(), []);
  const parsedValue = parseRopaReviewDeadlineDate(value);

  return (
    <KeyboardDatePicker
      autoFocus={autoFocus}
      autoOk
      error={Boolean(error)}
      format={DATE_FORMAT.defaultDate}
      fullWidth
      helperText={error}
      id={id}
      InputLabelProps={{ htmlFor: id, shrink: true }}
      inputProps={{ 'aria-label': label }}
      inputValue={value}
      inputVariant='outlined'
      invalidDateMessage=''
      KeyboardButtonProps={{ 'aria-label': `${label} calendar` }}
      label={label}
      margin='normal'
      maxDate={max}
      maxDateMessage=''
      minDate={tomorrow}
      minDateMessage=''
      onChange={(date, inputValue) => {
        if (typeof inputValue === 'string') {
          onChange(inputValue);
          return;
        }

        if (inputValue === null) {
          onChange('');
          return;
        }

        if (date && isValid(date)) {
          onChange(format(date, DATE_FORMAT.defaultDate));
          return;
        }

        onChange('');
      }}
      placeholder={DATE_FORMAT.defaultDate.toLowerCase()}
      refuse={neverRefuse}
      rifmFormatter={passThroughInput}
      value={parsedValue}
      variant='inline'
    />
  );
};

export default RopaReviewDeadlineField;
